import type { RefObject } from 'react'
import { Button } from '@/components/ui/button'
import { CVParsingStatus } from '@/components/ui/cv-parsing-status'
import type { CVDocument } from '@/hooks/use-cv-upload'

export function OwnCvFileInput({
  inputRef,
  accept,
  onFiles,
}: {
  inputRef: RefObject<HTMLInputElement | null>
  accept: string
  onFiles: (files: FileList | null) => void
}) {
  return (
    <input
      ref={inputRef}
      type="file"
      accept={accept}
      className="sr-only"
      onChange={(event) => void onFiles(event.target.files)}
    />
  )
}

export function OwnCvStatusPanel({
  primary,
  isProcessing,
  isFailed,
  error,
  busy,
  isRetrying,
  hasOwnCvFile,
  uploading,
  onPickFile,
  onRetry,
}: {
  primary: CVDocument | null
  isProcessing: boolean
  isFailed: boolean
  error: string | null
  busy: boolean
  isRetrying: boolean
  hasOwnCvFile: boolean
  uploading: boolean
  onPickFile: () => void
  onRetry: () => void
}) {
  const showStatus = !!primary && (isProcessing || isFailed)
  if (!showStatus && !error && hasOwnCvFile) return null

  return (
    <div className="space-y-3">
      {showStatus && primary ? (
        <div className="space-y-2">
          <CVParsingStatus cvDocument={primary} />
          {isFailed ? (
            <div className="flex flex-wrap gap-2">
              <Button type="button" variant="outline" size="sm" onClick={onPickFile} disabled={busy}>
                Upload new file
              </Button>
              <Button type="button" size="sm" onClick={onRetry} disabled={busy}>
                {isRetrying ? 'Retrying…' : 'Retry processing'}
              </Button>
            </div>
          ) : null}
        </div>
      ) : null}
      {error ? <p className="text-sm text-destructive">{error}</p> : null}
      {!hasOwnCvFile && !isProcessing ? (
        <Button type="button" variant="outline" size="sm" onClick={onPickFile} disabled={busy}>
          {uploading ? 'Uploading…' : 'Add your CV'}
        </Button>
      ) : null}
    </div>
  )
}
